import { StatisticNumberOfTimesExceededDataItem, NumberOfTimesExceededsItem } from "../../models/types/statistic";
import { useLookupParameter } from "../../utils/get-lookup";
import dayjs from "dayjs";

type TableProps = {
    staticData: StatisticNumberOfTimesExceededDataItem[];
    listVisibleParameter: any[];
    loading?: boolean;
}
const StatisticTable = ({ staticData, listVisibleParameter, loading }: TableProps) => {
    const { lookupParameter } = useLookupParameter();
    // Tìm số lần vượt ngưỡng lớn nhất
    // const maxThresholdTimes = Math.max(
    //     ...staticData.map((item: StatisticNumberOfTimesExceededDataItem) => item.thresholdCrossingTimes?.length || 0)
    // );

    return (
        <table className="max-h-full w-full statistic-table">
            <thead className="sticky top-[-1px] z-1">
                <tr className="">
                    <th className="px-2 py-1">Trạm quan trắc</th>
                    {listVisibleParameter.map((item: any, index: number) => {
                        return (
                            <th key={index} className="px-2 py-1">{item.label}</th>
                        )
                    })}
                </tr>

            </thead>
            <tbody className="bg-white">
                {loading ? (
                    <tr>
                        <td colSpan={listVisibleParameter.length + 1} className="text-center py-4">
                            <div className="flex items-center justify-center">
                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-900"></div>
                            </div>
                        </td>
                    </tr>
                ) : staticData?.length === 0 ? (
                    <tr>
                        <td colSpan={listVisibleParameter.length + 1} className="text-center py-4">
                            <div className="flex items-center justify-center">
                                <div className="text-gray-500">Chưa có dữ liệu</div>
                            </div>
                        </td>
                    </tr>
                ) : staticData?.map((item: StatisticNumberOfTimesExceededDataItem, index: number) => {
                    // const unit = lookupParameter.find((p: any) => p.id === item.parameterId)?.unitName;
                    return (
                        <tr key={index} className="border-b border-gray-300 bg-[repeating-linear-gradient(45deg,_#c5c5c5_0_10px,_#fff_10px_20px)]">
                            <td className="px-2 py-1 !text-left bg-white">{item.stationName}</td>
                            {listVisibleParameter?.map((parameter: any, idx: number) => {
                                const numberOfTimesExceededs = item.numberOfTimesExceededs.find((p: any) => p.parameterName === parameter.label);
                                if (!numberOfTimesExceededs) {
                                    return (
                                        <td key={index + idx} className="bg-transparent"></td>
                                    )
                                }
                                return (
                                    <td key={index + idx} className="px-2 py-1 bg-white">{numberOfTimesExceededs?.count}</td>
                                )
                            })}
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}

export default StatisticTable;
